import { LoanBaseDto } from 'api/borrower';
import { GenericLoading } from 'components/ui/Loader';
import { CardsSection } from 'components/layout/Section/CardsSection';
import { NsKey } from 'enums/NsKey';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { FC } from 'react';
import { LoanInfoCard } from './LoanInfoCard';
import { GuaranteeOptionsCard } from './GuaranteeOptionsCard';
import { GuaranteesList } from './GuaranteesList';
import { useBorrowerGuaranteeForm } from '../hooks/useBorrowerGuaranteeForm';

interface BorrowerGuaranteeLayoutProps {
  loan: LoanBaseDto;
}

export const BorrowerGuaranteeLayout: FC<BorrowerGuaranteeLayoutProps> = ({ loan }) => {
  const { t } = useDynamicTranslation([NsKey.Borrower, NsKey.Common, NsKey.Pricing]);

  const {
    insured,
    insuredCivility,
    isITTActive,
    isIPTActive,
    activeGuaranteeIds,
    requiredGuarantees,
    optionalGuarantees,
    getLoanTypeLabel,
    isActive,
    isAvailable,
    getMissingDeps,
    handleToggleGuarantee,
    showGuaranteeDetails
  } = useBorrowerGuaranteeForm();

  if (!insured) {
    return <GenericLoading loading isParentSized />;
  }

  const loanTypeLabel = getLoanTypeLabel(loan.loanTypeId);

  return (
    <div className="font-lato flex flex-col gap-4">
      <CardsSection title={t('PRICING.BORROWER.LOAN_INFOS')}>
        <LoanInfoCard
          insured={insured}
          insuredCivility={insuredCivility}
          loan={loan}
          loanTypeLabel={loanTypeLabel}
        />
        <GuaranteeOptionsCard
          isITTActive={isITTActive}
          isIPTActive={isIPTActive}
        />
      </CardsSection>

      <GuaranteesList
        requiredGuarantees={requiredGuarantees}
        optionalGuarantees={optionalGuarantees}
        activeGuaranteeIds={activeGuaranteeIds}
        isActive={isActive}
        isAvailable={isAvailable}
        getMissingDeps={getMissingDeps}
        onToggle={handleToggleGuarantee}
        onShowDetails={showGuaranteeDetails}
      />
    </div>
  );
};
